export default "__VITE_ASSET__gSz6M2zZ__"